{
  "CodeDeliveryFailureException": "Impossibile inviare il codice. Riprova più tardi.",
  "CodeMismatchException": "Il codice inserito non è valido. Controlla nuovamente e riprova.",
  "ExpiredCodeException": "Questo codice è scaduto.",
  "InvalidParemeterException": "Qualcosa è andato storto. Riprova più tardi.",
  "LimitExceededException": "Troppi tentativi. Riprova più tardi.",
  "NotAuthorizedException": "La tua email e/o password non sono corrette.",
  "UserNotConfirmedException": "L'account non è confermato.",
  "UserNotFoundException": "La tua email e/o password non sono corrette.",
  "UsernameExistsException": "L'account esiste già.",
  "accountNotConfirmed": "Account non confermato",
  "anUnknownErrorOccurred": "Si è verificato un errore sconosciuto",
  "codeSentToast": "Codice inviato.",
  "codeStringFieldLabel": "Codice",
  "codeStringFieldPlaceholder": "Inserisci il codice",
  "confirmAccount": "Conferma account",
  "confirmAccountButton": "Conferma account",
  "confirmPasswordFieldLabel": "Conferma password",
  "confirmPasswordFieldPlaceholder": "*******",
  "contactUs": "Contattaci",
  "createAnAccount": "Creare un account",
  "createUserAccount": "Crea un account utente",
  "credentialsSuccess": "Ora puoi accedere con le tue nuove credenziali.",
  "currentPasswordFieldLabel": "Password",
  "currentPasswordFieldPlaceholder": "*******",
  "emailFieldLabel": "E-mail",
  "emailFieldPlaceholder": "*******@esempio.com",
  "enterCodeFromYourEmail": "Inserisci il codice di conferma che abbiamo inviato al tuo indirizzo email.",
  "enterYourEmail": "Inserisci il tuo indirizzo email",
  "needToConfirmYourAccount": "Hai bisogno di confermare il tuo account?",
  "newPasswordFieldLabel": "Password",
  "newPasswordFieldPlaceholder": "Inserisci la password",
  "passwordResetCodeSentWithEmail": "Abbiamo inviato un codice di reimpostazione della password monouso a {{email}} (assicurati di controllare il tuo filtro antispam)",
  "passwordResetLinkTo": "Hai dimenticato la password?",
  "passwordResetTitle": "Reimposta password",
  "signIn": "Registrazione",
  "signOut": "Disconnessione",
  "youMustConfirmYourAccount": "Devi confermare il tuo account prima di poter effettuare l'accesso."
}
